import React from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import ReactGA from "react-ga";
import _ from "lodash";
import { getCurrentPage } from "../helpers";

import Footer from "./Footer";
import Seo from "./Seo";
import POIItem from "./POIItem";

class PublicPumps extends React.Component {
    title = () => {
        return "Bike rentals in Bristol, Bath & NE Somerset, North Somerset, and South Gloucestershire";
    };

    desc = () => {
        return "Find out where to rent a bike in Bristol, Bath & NE Somerset, North Somerset, and South Gloucestershire";
    };

     // GA Track
     trackClick = (link) => {
        ReactGA.event({
            category: _.startCase(getCurrentPage()),
            action: `Clicked link ${link}`,
            label: link,
        });
    };

    render() {
        return (
            <div>
                <Seo title={this.title()} desc={this.desc()} />

                <CSSTransitionGroup
                    transitionName="slide-fade"
                    transitionAppear={true}
                    transitionAppearTimeout={400}
                    transitionEnterTimeout={400}
                    transitionLeaveTimeout={400}
                >
                    <div className="public-pumps">
                        <header className="public-pumps__header">
                            <h1 className="main-title">Public Bike Pumps</h1>
                            <p className="tagline">
                                We have installed on-street bike pumps located
                                around the Greater Bristol area to help keep you
                                enjoying your ride.
                            </p>
                        </header>

                        <div className="public-pumps__info">
                            <svg className="tab-illustration">
                                <use xlinkHref="#ill-bike-rentals" />
                            </svg>
                            <div className="public-pumps__item">
                                <h3 className="underline-heading">Locations</h3>
                                <POIItem
                                    poiType="bikePumps"
                                    label="Show on map"
                                    {...this.props}
                                />
                            </div>
                            <div className="public-pumps__item">
                                <h3 className="underline-heading">
                                    Public Bike Pumps
                                </h3>
                                <a
                                    className="forward-title"
                                    href="https://betterbybike.info/shops-and-repair/public-bike-pumps/"
                                    onClick={ (e) => this.trackClick('Visit our Public Bike Pumps page') }
                                >
                                    Visit our Public Bike Pumps page
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </CSSTransitionGroup>
            </div>
        );
    }
}

export default PublicPumps;



// WEBPACK FOOTER //
// ./src/components/PublicPumps.js